import { connect } from 'react-redux';

import * as bucketConstants from '../../../constants/buckets';
import AddMemberTrigger from '../../../components/addMember/AddMemberTrigger';

const mapDispatchToProps = dispatch => ({
    showAddMembers: () =>
        dispatch({
            type: bucketConstants.TOGGLE_ADD_MEMBER,
            payload: { isAddMember: true },
        }),
});

export default connect(
    undefined,
    mapDispatchToProps,
)(AddMemberTrigger);



// WEBPACK FOOTER //
// ./src/containers/bucketMembers/addBucketMembers/AddBucketMembersTrigger.js